(function () {
	'use strict';
	angular.module('app.setup')
		.controller('auditLog', auditLog);
    
	function auditLog($rootScope, $scope, leanFilterService, tableRenderService, $timeout,
			tableService, pageTimingService) {
        
		var vm = this;
		var timingCalled = false;
		var getDataCalled = false;
		var showRowsCalled = false;

		vm.getData = getData;
		vm.getMeta = getMeta;

		var columnList = columns();
		var pinnedColumnList = [];

		vm.reportName = 'Audit Log';

		var userTimingListener = $scope.$on('showRowsCalled', function () {
			showRowsCalled = true;
			submitUserTiming();
		});
		$scope.$on('$destroy', function () {
			userTimingListener();
		});

		function submitUserTiming() {
			if (getDataCalled && showRowsCalled && !timingCalled) {
				pageTimingService.submitUserTiming('Audit Log');
				timingCalled = true;
			}
		}

		var reportSettingsName = 'auditLog';

		var rendererParams = {};

		var extraParams = [{}];
        
		var defaultFilters = [];

		vm.extraFilters = [];
		vm.showExcel = false;
		leanFilterService.clearFilters();
		leanFilterService.useFactoryFilter = false;
		var filters = [
			leanFilterService.filterDefinitions['CustomersForUser'],
			leanFilterService.filterDefinitions['AuditLogObjectTypes']
		];
		leanFilterService.setMasterFilterList(filters);
		leanFilterService.setMasterRangeFilterList([leanFilterService.filterDefinitions['Timestamp'], leanFilterService.filterDefinitions['AuditLogObjectId']]);
		leanFilterService.searchType = 'user';
		function getMeta() {
			return {
				reportSettingsName: reportSettingsName,
				noPaging: false,
				pageSize: 50,
				defaultFilters: defaultFilters,
				defaultSort: 'dateCreated',
				defaultSortDirection: 'desc',
				rendererParams: rendererParams,
				extraParams: extraParams,
				columns: columnList,
				reportUrl: 'AuditLogReport' ,
				pinnedColumns: pinnedColumnList,
				hideSearch: false,
				footer: false,
				setColumnDefaults: true,
				noFactory: true,
				searchType: 'user',
				specialPlaceholderText: 'Search actor email',
				isGlobalReportSetting: true
			};
		}

		function getData(params, extraParams) {
			return tableService.postData(params, extraParams, getReportColumns()).then(function (response) {
				getDataCalled = true;
				return response;
			});
		}

		function getReportColumns() {
			var newColumns = [
				'customerNdx', 'message'
			];
			newColumns = _.map(newColumns, function(val) {
				return {id: val};
			});
			return columns().concat(newColumns);
		}

		function columns() {
			return [
				{
					id: 'customer',
					display: 'Customer',
					sort: false,
					width: 100
				},
				{
					id: 'factoryAlias',
					display: 'Site',
					sort: false,
					width: 100
				},
				{
					id: 'dateCreated',
					display: 'Timestamp',
					renderer: tableRenderService.dateTime,
					width: 150,
					sortDefaultReverse: true					
				},
				{
					id: 'actorName',
					display: 'Actor',
					sort: false,
					show: false,
					width: 150
				},
				{
					id: 'actorEmail',
					display: 'Actor Email',
					sort: false,
					show: false,
					width: 120
				},
				{
					id: 'objectType',
					display: 'Object Type',
					sort: false,
					width: 100
				},
				{
					id: 'operation',
					display: 'Operation',
					sort: false,
					width: 80
				},
				{
					id: 'objectId',
					display: 'Object ID',
					sort: false,
					show: false,
					width: 80
				},
				{
					id: 'object',
					display: 'Object',
					sort: false,
					width: 120
				},
				{
					id: 'content',
					display: 'Content',
					renderer: tableRenderService.auditLogContent,
					sort: false,
					width: 150
				}
			];
		}
	
	}
})();
